import { Component, effect, input, inject, signal, computed } from '@angular/core';

import { CommonModule } from '@angular/common';

import { combineLatest, BehaviorSubject, map } from 'rxjs';

import { TeamLogoLookupPipe } from '../shared/team-logo-lookup.pipe';
import { TimespanMsPipe, TimespanShortPipe } from '../shared/time-span.pipe';
import { VbLxpTooltipComponent } from '../tooltip/vb-lxp-tooltip.component';

import { ISessionEntry } from './IRaceTiming';
import { RaceSessionService } from './race-session.service';
import { TimingTowerService } from './timing-tower.service';

@Component({
  selector: 'vb-lxp-timing-tower-full',
  imports: [
    CommonModule,
    TeamLogoLookupPipe,
    TimespanMsPipe,
    TimespanShortPipe,
    VbLxpTooltipComponent,
  ],
  templateUrl: './timing-tower-full.component.html',
  styleUrl: './timing-tower-full.component.css',
})
export class TimingTowerFullComponent {
  public activeClass = input('');
  public activeNumberClass = input('');
  public selectedClasses = input<string[]>([]);

  public raceSessionService = inject(RaceSessionService);
  public timingTowerService = inject(TimingTowerService);

  public hoveredTeam = signal<any>(null);
  public tooltipTop = signal(0);
  public tooltipLeft = signal(0);

  protected readonly selectedClassSubject$ = new BehaviorSubject<string[]>([]);
  entries = computed(() => this.raceSessionService.raceTeamsPosition());
  teams = computed(() => {
    const selectedClasses = this.selectedClasses();
    if (!this.entries()) return [];

    console.log(this.entries());
    return this.entries()
      .map((entry) => {
        if (!entry?.activeStanding) {
          return;
        }

        return {
          ...entry,
          positionChangeState:
            entry.activeStanding.positionChange > 0
              ? 'up'
              : entry.activeStanding.positionChange < 0
                ? 'down'
                : 'neutral',
          flashState: entry.activeStanding.positionChange !== 0 ? 'active' : 'inactive',
        } as any;
      })
      .filter((entry) => {
        return entry && (selectedClasses.length === 0 || selectedClasses.includes(entry.class));
      });
  });

  constructor() {
    effect(() => {
      this.raceSessionService.raceTeamsPosition();
      this.selectedClassSubject$.next(this.selectedClasses());
    });
  }

  public toggleTeamSelection(team: ISessionEntry) {
    this.timingTowerService.toggleActive(team.number);
  }
  public showTooltip(team: any, event: MouseEvent): void {
    this.hoveredTeam.set(team);
    const x = event.clientX;
    const y = event.clientY;
    const tooltipWidth = 310;
    this.tooltipLeft.set(
      x + tooltipWidth + 20 > window.innerWidth ? x - tooltipWidth - 10 : x + 10,
    );
    this.tooltipTop.set(Math.min(y - 20, window.innerHeight - 220));
  }

  public hideTooltip(): void {
    this.hoveredTeam.set(null);
  }

  public trackByFn(index: number, item: any): string {
    return item.number; // assuming unique team number
  }
}
